export default __webpack_public_path__ + "static/media/MarginImpactInputs.69854ab6.png";